
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const ServiceDetail = lazy(() => import('../pages/services/detail/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Appointment = lazy(() => import('../pages/appointment/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Auth pages
const Login = lazy(() => import('../pages/auth/login/page'));
const Register = lazy(() => import('../pages/auth/register/page'));

// Admin pages
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminAppointments = lazy(() => import('../pages/admin/appointments/page'));
const AdminServices = lazy(() => import('../pages/admin/services/page'));
const AdminGallery = lazy(() => import('../pages/admin/gallery/page'));
const AdminVideos = lazy(() => import('../pages/admin/videos/page'));
const AdminBanners = lazy(() => import('../pages/admin/banners/page'));
const AdminTestimonials = lazy(() => import('../pages/admin/testimonials/page'));
const AdminTeam = lazy(() => import('../pages/admin/team/page'));
const AdminCampaigns = lazy(() => import('../pages/admin/campaigns/page'));
const AdminPageContent = lazy(() => import('../pages/admin/page-content/page'));
const AdminSettings = lazy(() => import('../pages/admin/settings/page'));
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminMessages = lazy(() => import('../pages/admin/messages/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/services',
    element: <Services />
  },
  {
    path: '/services/:slug',
    element: <ServiceDetail />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/appointment',
    element: <Appointment />
  },
  {
    path: '/auth/login',
    element: <Login />
  },
  {
    path: '/auth/register',
    element: <Register />
  },
  {
    path: '/admin/login',
    element: <AdminLogin />
  },
  {
    path: '/admin',
    element: <ProtectedRoute requireAdmin={true}><AdminDashboard /></ProtectedRoute>
  },
  {
    path: '/admin/dashboard',
    element: <ProtectedRoute requireAdmin={true}><AdminDashboard /></ProtectedRoute>
  },
  {
    path: '/admin/appointments',
    element: <ProtectedRoute requireAdmin={true}><AdminAppointments /></ProtectedRoute>
  },
  {
    path: '/admin/services',
    element: <ProtectedRoute requireAdmin={true}><AdminServices /></ProtectedRoute>
  },
  {
    path: '/admin/gallery',
    element: <ProtectedRoute requireAdmin={true}><AdminGallery /></ProtectedRoute>
  },
  {
    path: '/admin/videos',
    element: <ProtectedRoute requireAdmin={true}><AdminVideos /></ProtectedRoute>
  },
  {
    path: '/admin/banners',
    element: <ProtectedRoute requireAdmin={true}><AdminBanners /></ProtectedRoute>
  },
  {
    path: '/admin/testimonials',
    element: <ProtectedRoute requireAdmin={true}><AdminTestimonials /></ProtectedRoute>
  },
  {
    path: '/admin/team',
    element: <ProtectedRoute requireAdmin={true}><AdminTeam /></ProtectedRoute>
  },
  {
    path: '/admin/campaigns',
    element: <ProtectedRoute requireAdmin={true}><AdminCampaigns /></ProtectedRoute>
  },
  {
    path: '/admin/page-content',
    element: <ProtectedRoute requireAdmin={true}><AdminPageContent /></ProtectedRoute>
  },
  {
    path: '/admin/messages',
    element: <ProtectedRoute requireAdmin={true}><AdminMessages /></ProtectedRoute>
  },
  {
    path: '/admin/settings',
    element: <ProtectedRoute requireAdmin={true}><AdminSettings /></ProtectedRoute>
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
